// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCbgQnM5cDExd_lt9g3ZA1Y6b3ooXiK0C8",
  authDomain: "eleverewebsitelandingpage.firebaseapp.com",
  projectId: "eleverewebsitelandingpage",
  storageBucket: "eleverewebsitelandingpage.appspot.com",
  messagingSenderId: "606749221133",
  appId: "1:606749221133:web:82f98b873878d6df8f1044",
  measurementId: "G-QFV77KFCNT"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const analytics = getAnalytics(app);

const firebaseExports = { app, db, analytics }; // Assigning to a variable

export default firebaseExports; // Exporting the variable